/**
 * Utility functions for consistent date formatting throughout the application
 */

/**
 * Formats a date string to the complete format: "28 April 2026"
 * @param {string|Date} dateString - The date to format
 * @returns {string} - Formatted date string or "N/A" if invalid
 */
export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";
    
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
  } catch (error) {
    console.error("Error formatting date:", error);
    return "N/A";
  }
};

/**
 * Formats a date string to the complete format with locale: "28 April 2026"
 * Uses en-US locale for consistent "April" format instead of "Apr"
 * @param {string|Date} dateString - The date to format
 * @returns {string} - Formatted date string or "N/A" if invalid
 */
export const formatDateComplete = (dateString) => {
  return formatDate(dateString);
};

/**
 * Formats a date string to short format: "28 Apr 2026"
 * @param {string|Date} dateString - The date to format
 * @returns {string} - Formatted date string or "N/A" if invalid
 */
export const formatDateShort = (dateString) => {
  if (!dateString) return "N/A";
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";
    
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric"
    });
  } catch (error) {
    console.error("Error formatting date:", error);
    return "N/A";
  }
};

/**
 * Default export for convenience
 */
export default formatDate;
